import { Rarity } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { useLifecycle } from '#src/hooks/useLifecycle.ts';

export const useFilteredShardsChests = () => {
  const { currentUser } = useCurrentUserContext();
  const { lifecycle } = useLifecycle();
  const seriesNav = useSeriesNav();

  const { cardShardsChests } = currentUser || {};

  return cardShardsChests?.filter(shard => {
    if (lifecycle?.hideCommonFeatures) {
      return shard.rarity !== Rarity.common;
    }
    if (seriesNav) {
      return shard.cardSet?.slug === 'winter';
    }
    return true;
  });
};
